import Joi from 'joi';
import type { IShowKeyboardPayload } from './showKeyboardAction';
import { showKeyboardPayloadSchema } from './showKeyboardAction';
import { actionCreator, objectSchemaOf } from '../helpers';
import { USER_INPUT_INPUT } from './topics';

export const KEYBOARD_DISPLAYED = 'USER_INPUT/KEYBOARD_DISPLAYED';

export interface IKeyboardDisplayedAction {
  type: typeof KEYBOARD_DISPLAYED;
  payload: IShowKeyboardPayload;
}

export const keyboardDisplayedActionSchema = objectSchemaOf<IKeyboardDisplayedAction>(
  {
    type: Joi.string().required().valid(KEYBOARD_DISPLAYED),
    payload: showKeyboardPayloadSchema.required(),
  }
);

export const keyboardDisplayed = actionCreator({
  type: KEYBOARD_DISPLAYED,
  schema: keyboardDisplayedActionSchema,
  topic: USER_INPUT_INPUT,
});
